<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar moneda</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editCurrencyForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{currencyData.id}}</p>
            <p><strong>Fecha de creación: </strong>{{currencyData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
                <mat-label>País/región</mat-label>
                <input matInput type="text" placeholder="ej. EEUU"
                    formControlName="country" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('country', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Divisa</mat-label>
                <input matInput type="text" placeholder="ej. Dólar"
                    formControlName="currency" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('currency', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Divisa símbolo</mat-label>
                <input matInput type="text" placeholder="ej. $"
                    formControlName="symbol" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('symbol', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>Divisa Abreviatura</mat-label>
                <input matInput type="text" placeholder="ej. USD"
                    formControlName="abbreviation" autocomplete="off" />
                <mat-error *ngIf="isControlHasError('abbreviation', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-100">
                <mat-label>IVA</mat-label>
                <input matInput type="text" placeholder="ej. 0.19"
                       formControlName="iva" autocomplete="off"/>
                    <span matSuffix>%&nbsp;</span>
                <mat-error *ngIf="isControlHasError('iva', 'required')">
                    <strong>Campo requerido</strong>
                </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="submit(editCurrencyForm)">Guardar</button>
    </div>
</div>
